
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

const PolitiqueConfidentialite = () => {
  useEffect(() => {
    console.log("PolitiqueConfidentialite component rendered", {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      hash: window.location.hash,
      pathname: window.location.pathname
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold mb-8">Politique de confidentialité</h1>
          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold mb-4">Politique de confidentialité de l'association "Enfants de la République"</h2>
            
            <h3 className="text-xl font-semibold mb-3">Introduction</h3>
            <p className="mb-4">
              L'association "Enfants de la République" (ci-après dénommée « l'Association ») accorde une grande importance à la protection de vos données personnelles. 
              Nous nous engageons à respecter la législation en vigueur, en particulier le Règlement Général sur la Protection des Données (RGPD) de l'Union Européenne, 
              afin de garantir la sécurité, la confidentialité et la transparence sur la collecte et le traitement de vos données personnelles.
            </p>
            <p className="mb-6">
              La présente politique de confidentialité a pour but de vous informer sur la manière dont nous collectons, utilisons, et protégeons vos données personnelles.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">1. Responsable du traitement des données</h3>
            <p className="mb-6">
              Le responsable du traitement des données personnelles est l'Association "Enfants de la République", 
              sise à [adresse complète], représentée par [nom du représentant légal], en sa qualité de [fonction du représentant légal].
            </p>
            
            <h3 className="text-xl font-semibold mb-3">2. Données collectées</h3>
            <p className="mb-4">
              Nous collectons les données personnelles suivantes dans le cadre de nos activités :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Nom et prénom</li>
              <li>Adresse e-mail</li>
              <li>Adresse postale</li>
              <li>Numéro de téléphone</li>
              <li>Date de naissance (le cas échéant)</li>
              <li>Informations relatives à la participation à nos événements ou programmes</li>
            </ul>
            <p className="mb-6">
              Les données sensibles, telles que des informations de santé, ne sont pas collectées à moins que cela ne soit nécessaire 
              pour la gestion d'un programme spécifique et avec votre consentement explicite.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">3. Finalités du traitement des données</h3>
            <p className="mb-4">
              Les données personnelles collectées sont utilisées dans les finalités suivantes :
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Gestion des adhésions et des inscriptions aux activités de l'Association</li>
              <li>Envoi de communications relatives aux événements, programmes et actualités de l'Association</li>
              <li>Gestion des dons et des financements</li>
              <li>Suivi administratif et organisationnel</li>
              <li>Respect des obligations légales et contractuelles</li>
            </ul>
            
            <h3 className="text-xl font-semibold mb-3">4. Base légale du traitement</h3>
            <p className="mb-4">
              Nous traitons vos données personnelles sur la base des fondements juridiques suivants :
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>
                <strong>Consentement :</strong> lorsque vous nous fournissez vos données personnelles pour une finalité spécifique 
                (ex. : inscription à un événement ou à une newsletter).
              </li>
              <li>
                <strong>Exécution d'un contrat :</strong> lorsque le traitement est nécessaire pour l'exécution d'un contrat auquel vous êtes partie 
                (ex. : gestion de l'adhésion).
              </li>
              <li>
                <strong>Obligations légales :</strong> lorsque le traitement est nécessaire pour respecter une obligation légale à laquelle nous sommes soumis.
              </li>
            </ul>
            
            <h3 className="text-xl font-semibold mb-3">5. Durée de conservation des données</h3>
            <p className="mb-4">
              Nous conservons vos données personnelles pendant une durée qui n'excède pas celle nécessaire aux finalités pour lesquelles elles ont été collectées. 
              Cette durée varie en fonction de la nature de la donnée et de la finalité du traitement.
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>
                Les données relatives à l'adhésion seront conservées pendant toute la durée de l'adhésion et, le cas échéant, 
                pour une période supplémentaire, conformément aux obligations légales.
              </li>
              <li>
                Les données relatives à la participation à un événement ou programme seront conservées pendant la durée de l'événement 
                et jusqu'à un an après sa clôture, sauf si une durée plus longue est justifiée par des obligations légales ou contractuelles.
              </li>
            </ul>
            
            <h3 className="text-xl font-semibold mb-3">6. Destinataires des données</h3>
            <p className="mb-4">
              Les données personnelles collectées peuvent être communiquées aux destinataires suivants :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Les membres de l'Association, dans le cadre de la gestion des adhésions et des activités.</li>
              <li>
                Les prestataires externes auxquels nous faisons appel pour la gestion des événements, la communication, 
                la gestion des paiements, etc., dans le respect de la confidentialité et de la sécurité des données.
              </li>
            </ul>
            <p className="mb-6">
              Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers non autorisés.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">7. Sécurisation des données</h3>
            <p className="mb-6">
              Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles 
              contre tout accès non autorisé, toute divulgation, altération ou destruction accidentelle ou illégale.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">8. Vos droits</h3>
            <p className="mb-4">
              Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>
                <strong>Droit d'accès :</strong> Vous avez le droit d'obtenir la confirmation que vos données personnelles sont ou non traitées, 
                et, si tel est le cas, d'accéder à ces données.
              </li>
              <li>
                <strong>Droit de rectification :</strong> Vous avez le droit de demander la rectification des données personnelles inexactes vous concernant.
              </li>
              <li>
                <strong>Droit à l'effacement :</strong> Vous avez le droit de demander l'effacement de vos données personnelles dans certaines situations.
              </li>
              <li>
                <strong>Droit d'opposition :</strong> Vous avez le droit de vous opposer, pour des raisons tenant à votre situation particulière, 
                au traitement de vos données personnelles.
              </li>
              <li>
                <strong>Droit à la limitation du traitement :</strong> Vous pouvez demander la limitation du traitement de vos données personnelles 
                dans certaines situations.
              </li>
              <li>
                <strong>Droit à la portabilité :</strong> Vous avez le droit de recevoir vos données personnelles dans un format structuré, 
                couramment utilisé et lisible par machine, et de les transmettre à un autre responsable du traitement.
              </li>
            </ul>
            <p className="mb-4">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : contact@ledlr.fr
            </p>
            <p className="mb-6">
              Si vous estimez que vos droits n'ont pas été respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale 
              de l'Informatique et des Libertés (CNIL) ou de l'autorité de protection des données compétente dans votre pays.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">9. Modifications de la politique de confidentialité</h3>
            <p className="mb-6">
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. En cas de modification substantielle, 
              nous vous en informerons par les moyens appropriés.
            </p>
            
            <h3 className="text-xl font-semibold mb-3">10. Contact</h3>
            <p className="mb-4">
              Pour toute question ou demande concernant cette politique de confidentialité, vous pouvez nous contacter à l'adresse suivante :
            </p>
            <p className="mb-1"><strong>Nom de l'association :</strong> ENFANTS DE LA REPUBLIQUE</p>
            <p className="mb-1"><strong>Adresse :</strong> 6 Rue Clément Marot, 75008 Paris</p>
            <p className="mb-1"><strong>Numéro de téléphone :</strong> 01 43 59 26 93</p>
            <p className="mb-6"><strong>Email :</strong> contact@ledlr.fr</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;
